export default "__VITE_ASSET__26REAqI1__"